import React, { lazy } from 'react'

import withLazyLoad from '../../components/withLazyLoader'

const Component = withLazyLoad(lazy(() => import(/* webpackChunkName: "GameRooms" */ './GameRoomsWithData')))

export default function Loadable() {
  return <Component />
}
